import { Environment } from '../../types';

export const getInternalProductId = (id: number) => {

  if (process.env.ENVIRONMENT === Environment.prod) {
    switch(id) {
      case 8:
        return 'everydoggy_1MONTH_29_99_USD';
        break;
      case 10:
        return 'everydoggy_3MONTH_39_99_USD';
        break;
      case 9:
        return 'everydoggy_1YEAR_69_99_USD';
        break;
      case 15:
        return 'everydoggy_1MONTH_21_99_USD';
        break;
      case 16:
        return 'everydoggy_3MONTH_29_99_USD';
        break;
      case 17:
        return 'everydoggy_1YEAR_51_99_USD';
        break;
      case 18:
        return 'everydoggy_1MONTH_39_99_USD_EVERYDOGGY_EVERYDOGGY';
        break;
      case 25:
        return 'everydoggy_1MONTH_23_99_USD_EVERYDOGGY';
        break;
      case 32:
        return 'everydoggy_1MONTH_31_99_USD_EVERYDOGGY';
        break;
      case 33:
        return 'everydoggy_3MONTH_43_99_USD_EVERYDOGGY';
        break;
      case 34:
        return 'everydoggy_3MONTH_31_99_USD_EVERYDOGGY';
        break;
      case 35:
        return 'everydoggy_1WEEK_9_99_USD';
        break;
      case 36:
        return 'everydoggy_1WEEK_7_99_USD';
        break;
      case 37:
        return 'everydoggy_1WEEK_12_99_USD';
        break;
      case 38:
        return 'everydoggy_1MONTH_29_99_USD_TRAINER_CHAT';
        break;
      case 39:
        return 'everydoggy_3MONTH_39_99_USD_TRAINER_CHAT';
        break;
      case 40:
        return 'everydoggy_1MONTH_39_99_USD_INTRO_7days_6_99_EVERYDOGGY';
        break;
      case 41:
        return 'everydoggy_1MONTH_39_99_USD_INTRO_30days_19_99_EVERYDOGGY';
        break;
      case 42:
        return 'everydoggy_3MONTH_59_99_USD_INTRO_90days_29_99_EVERYDOGGY';
        break;
      case 43:
        return 'everydoggy_1MONTH_39_99_USD_INTRO_7days_4_99_EVERYDOGGY';
        break;
      case 44:
        return 'everydoggy_1MONTH_39_99_USD_INTRO_30days_14_99_EVERYDOGGY';
        break;
      case 45:
        return 'everydoggy_3MONTH_59_99_USD_INTRO_90days_19_99_EVERYDOGGY';
        break;

      case 46:
        return 'everydoggy_1MONTH_23_99_GBP_EVERYDOGGY';
        break;
      case 47:
        return 'everydoggy_3MONTH_31_99_GBP_EVERYDOGGY';
        break;
      case 48:
        return 'everydoggy_1YEAR_55_99_GBP_EVERYDOGGY';
        break;

      case 49:
        return 'everydoggy_1MONTH_16_99_GBP_EVERYDOGGY';
        break;
      case 50:
        return 'everydoggy_3MONTH_23_99_GBP_EVERYDOGGY';
        break;
      case 51:
        return 'everydoggy_1YEAR_41_99_GBP_EVERYDOGGY';
        break;

      case 52:
        return 'everydoggy_1MONTH_59_99_USD_EVERYDOGGY';
        break;
      case 53:
        return 'everydoggy_3MONTH_101_99_USD_EVERYDOGGY';
        break;
      case 54:
        return 'everydoggy_6MONTH_149_99_USD_EVERYDOGGY';
        break;
      case 55:
        return 'everydoggy_1MONTH_44_99_USD_EVERYDOGGY';
        break;
      case 56:
        return 'everydoggy_3MONTH_75_99_USD_EVERYDOGGY';
        break;
      case 57:
        return 'everydoggy_6MONTH_111_99_USD_EVERYDOGGY';
        break;

      case 58:
        return 'everydoggy_1MONTH_49_99_USD_INTRO_30days_15_19_EVERYDOGGY';
        break;
      case 59:
        return 'everydoggy_3MONTH_79_99_USD_INTRO_90days_25_99_EVERYDOGGY';
        break;
      case 60:
        return 'everydoggy_6MONTH_119_99_USD_INTRO_180days_37_99_EVERYDOGGY';
        break;
      case 61:
        return 'everydoggy_1MONTH_49_99_USD_INTRO_30days_11_69_EVERYDOGGY';
        break;
      case 62:
        return 'everydoggy_3MONTH_79_99_USD_INTRO_90days_19_99_EVERYDOGGY';
        break;
      case 63:
        return 'everydoggy_6MONTH_119_99_USD_INTRO_180days_28_79_EVERYDOGGY';
        break;
      case 64:
        return 'everydoggy_1MONTH_39_99_USD_INTRO_30days_11_99_EVERYDOGGY';
        break;
      case 65:
        return 'everydoggy_1MONTH_49_99_USD_INTRO_7days_4_99_EVERYDOGGY';
        break;
      case 66:
        return 'everydoggy_1MONTH_49_99_USD_INTRO_30days_11_99_EVERYDOGGY';
        break;
      case 67:
        return 'everydoggy_1MONTH_49_99_USD_INTRO_7days_3_99_EVERYDOGGY';
        break;
      case 68:
        return 'everydoggy_1MONTH_49_99_USD_INTRO_30days_8_99_EVERYDOGGY';
        break;

      case 69:
        return 'everydoggy_1MONTH_59_99_USD_INTRO_7days_4_99_EVERYDOGGY';
        break;
      case 70:
        return 'everydoggy_1MONTH_59_99_USD_INTRO_30days_11_99_EVERYDOGGY';
        break;
      case 71:
        return 'everydoggy_3MONTH_119_99_USD_INTRO_90days_25_99_EVERYDOGGY';
        break;
      case 72:
        return 'everydoggy_1MONTH_59_99_USD_INTRO_7days_3_99_EVERYDOGGY';
        break;
      case 73:
        return 'everydoggy_1MONTH_59_99_USD_INTRO_30days_8_99_EVERYDOGGY';
        break;
      case 74:
        return 'everydoggy_3MONTH_119_99_USD_INTRO_90days_19_99_EVERYDOGGY';
        break;

      case 75:
        return 'everydoggy_3MONTH_59_99_USD_INTRO_90days_25_99_EVERYDOGGY';
        break;
      
      case 76:
        return 'everydoggy_1MONTH_39_99_USD_INTRO_7days_3_99_EVERYDOGGY_EVERYDOGGY';
        break;

      case 77:
        return 'everydoggy_1MONTH_39_99_USD_INTRO_30days_8_99_EVERYDOGGY_EVERYDOGGY';
        break;

      case 78:
        return 'everydoggy_1MONTH_49_99_USD_INTRO_7days_1_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 79:
        return 'everydoggy_1MONTH_49_99_USD_INTRO_30days_6_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 80:
        return 'everydoggy_3MONTH_79_99_USD_INTRO_90days_14_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 81:
        return 'everydoggy_1MONTH_49_99_USD_INTRO_7days_0_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 82:
        return 'everydoggy_3MONTH_79_99_USD_INTRO_90days_9_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 83:
        return 'everydoggy_1MONTH_49_99_USD_INTRO_30days_3_99_NONE_NONE';
        break;

      case 84:
        return 'everydoggy_2WEEK_29_99_USD_INTRO_7days_4_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 85:
        return 'everydoggy_2WEEK_29_99_USD_INTRO_30days_11_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 86:
        return 'everydoggy_1MONTH_49_99_USD_INTRO_90days_25_99_EVERYDOGGY_EVERYDOGGY';
        break;

      case 87:
        return 'everydoggy_2WEEK_29_99_USD_INTRO_7days_3_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 88:
        return 'everydoggy_2WEEK_29_99_USD_INTRO_30days_8_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 89:
        return 'everydoggy_1MONTH_49_99_USD_INTRO_90days_19_99_EVERYDOGGY_EVERYDOGGY';
        break;

      case 90:
        return 'everydoggy_2WEEK_29_99_USD_INTRO_7days_1_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 91:
        return 'everydoggy_2WEEK_29_99_USD_INTRO_30days_6_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 92:
        return 'everydoggy_1MONTH_49_99_USD_INTRO_90days_14_99_EVERYDOGGY_EVERYDOGGY';
        break;

      case 93:
        return 'everydoggy_2WEEK_29_99_USD_INTRO_7days_0_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 94:
        return 'everydoggy_2WEEK_29_99_USD_INTRO_30days_3_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 95:
        return 'everydoggy_1MONTH_49_99_USD_INTRO_90days_9_99_EVERYDOGGY_EVERYDOGGY';
        break;

      case 96:
        return 'everydoggy_3MONTH_59_99_USD_INTRO_90days_39_99_EVERYDOGGY_EVERYDOGGY';
        break;

      case 98:
        return 'everydoggy_2WEEK_29_99_GBP_INTRO_7days_1_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 99:
        return 'everydoggy_2WEEK_29_99_GBP_INTRO_30days_6_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 100:
        return 'everydoggy_1MONTH_49_99_GBP_INTRO_90days_14_99_EVERYDOGGY_EVERYDOGGY';
        break;

      case 101:
        return 'everydoggy_2WEEK_29_99_GBP_INTRO_7days_0_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 102:
        return 'everydoggy_2WEEK_29_99_GBP_INTRO_30days_3_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 103:
        return 'everydoggy_1MONTH_49_99_GBP_INTRO_90days_9_99_EVERYDOGGY_EVERYDOGGY';
        break;

      case 104:
        return 'everydoggy_2WEEK_29_99_EUR_INTRO_7days_1_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 105:
        return 'everydoggy_2WEEK_29_99_EUR_INTRO_30days_6_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 106:
        return 'everydoggy_1MONTH_49_99_EUR_INTRO_90days_14_99_EVERYDOGGY_EVERYDOGGY';
        break;

      case 107:
        return 'everydoggy_2WEEK_29_99_EUR_INTRO_7days_0_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 108:
        return 'everydoggy_2WEEK_29_99_EUR_INTRO_30days_3_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 109:
        return 'everydoggy_1MONTH_49_99_EUR_INTRO_90days_9_99_EVERYDOGGY_EVERYDOGGY';
        break;

      case 110:
        return 'everydoggy_1MONTH_49_99_GBP_INTRO_7days_4_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 111:
        return 'everydoggy_1MONTH_49_99_GBP_INTRO_30days_11_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 112:
        return 'everydoggy_3MONTH_79_99_GBP_INTRO_90days_25_99_EVERYDOGGY_EVERYDOGGY';
        break;

      case 116:
        return 'everydoggy_1MONTH_29_99_USD_INTRO_30days_1_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 117:
        return 'everydoggy_1MONTH_29_99_GBP_INTRO_30days_1_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 118:
        return 'everydoggy_1MONTH_29_99_EUR_INTRO_30days_1_99_EVERYDOGGY_EVERYDOGGY';
        break;

      case 113:
        return 'everydoggy_1MONTH_49_99_GBP_INTRO_7days_3_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 114:
        return 'everydoggy_1MONTH_49_99_GBP_INTRO_30days_8_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 115:
        return 'everydoggy_3MONTH_79_99_GBP_INTRO_90days_19_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 119:
        return 'everydoggy_1MONTH_39_99_USD_INTRO_30days_19_99_TRAINER_CHAT_EVERYDOGGY_EVERYDOGGY';
        break;
      case 120:
        return 'everydoggy_1MONTH_39_99_GBP_INTRO_30days_19_99_TRAINER_CHAT_EVERYDOGGY_EVERYDOGGY';
        break;
      case 121:
        return 'everydoggy_1MONTH_39_99_EUR_INTRO_30days_19_99_TRAINER_CHAT_EVERYDOGGY_EVERYDOGGY';
        break;

      case 125:
        return 'everydoggy_1MONTH_39_99_GBP_EVERYDOGGY_EVERYDOGGY';
        break;
      case 126:
        return 'everydoggy_1MONTH_39_99_GBP_INTRO_30days_14_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 127:
        return 'everydoggy_3MONTH_59_99_GBP_INTRO_90days_39_99_EVERYDOGGY_EVERYDOGGY';
        break;

      case 128:
        return 'everydoggy_1MONTH_39_99_GBP_INTRO_30days_11_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 129:
        return 'everydoggy_3MONTH_59_99_GBP_INTRO_90days_29_99_EVERYDOGGY_EVERYDOGGY';
        break;

      case 130:
        return 'everydoggy_1MONTH_39_99_EUR_EVERYDOGGY_EVERYDOGGY';
        break;
      case 131:
        return 'everydoggy_1MONTH_39_99_EUR_INTRO_30days_14_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 132:
        return 'everydoggy_3MONTH_59_99_EUR_INTRO_90days_39_99_EVERYDOGGY_EVERYDOGGY';
        break;

      case 133:
        return 'everydoggy_1MONTH_39_99_EUR_INTRO_30days_11_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 134:
        return 'everydoggy_3MONTH_59_99_EUR_INTRO_90days_29_99_EVERYDOGGY_EVERYDOGGY';
        break;

      case 135:
        return 'everydoggy_3MONTH_64_99_USD_INTRO_90days_25_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 136:
        return 'everydoggy_6MONTH_94_99_USD_INTRO_180days_37_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 137:
        return 'everydoggy_3MONTH_64_99_USD_INTRO_90days_19_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 138:
        return 'everydoggy_6MONTH_94_99_USD_INTRO_180days_29_99_EVERYDOGGY_EVERYDOGGY';
        break;
        
      case 139:
        return 'everydoggy_3MONTH_64_99_GBP_INTRO_90days_25_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 140:
        return 'everydoggy_6MONTH_94_99_GBP_INTRO_180days_37_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 141:
        return 'everydoggy_3MONTH_64_99_GBP_INTRO_90days_19_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 142:
        return 'everydoggy_6MONTH_94_99_GBP_INTRO_180days_29_99_EVERYDOGGY_EVERYDOGGY';
        break;

      case 143:
        return 'everydoggy_3MONTH_64_99_EUR_INTRO_90days_25_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 144:
        return 'everydoggy_6MONTH_94_99_EUR_INTRO_180days_37_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 145:
        return 'everydoggy_3MONTH_64_99_EUR_INTRO_90days_19_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 146:
        return 'everydoggy_6MONTH_94_99_EUR_INTRO_180days_29_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 147:
        return 'everydoggy_3MONTH_64_99_USD_INTRO_90days_21_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 148:
        return 'everydoggy_6MONTH_94_99_USD_INTRO_180days_32_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 149:
        return 'everydoggy_3MONTH_64_99_GBP_INTRO_90days_21_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 150:
        return 'everydoggy_6MONTH_94_99_GBP_INTRO_180days_32_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 151:
        return 'everydoggy_3MONTH_64_99_EUR_INTRO_90days_21_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 152:
        return 'everydoggy_6MONTH_94_99_EUR_INTRO_180days_32_99_EVERYDOGGY_EVERYDOGGY';
        break;

      case 153:
        return 'everydoggy_2WEEK_39_99_USD_INTRO_30days_11_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 154:
        return 'everydoggy_1MONTH_49_99_USD_INTRO_90days_21_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 155:
        return 'everydoggy_1MONTH_49_99_USD_INTRO_180days_32_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 156:
        return 'everydoggy_2WEEK_39_99_GBP_INTRO_30days_11_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 157:
        return 'everydoggy_1MONTH_49_99_GBP_INTRO_90days_21_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 158:
        return 'everydoggy_1MONTH_49_99_GBP_INTRO_180days_32_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 159:
        return 'everydoggy_2WEEK_39_99_EUR_INTRO_30days_11_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 160:
        return 'everydoggy_1MONTH_49_99_EUR_INTRO_90days_21_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 161:
        return 'everydoggy_1MONTH_49_99_EUR_INTRO_180days_32_99_EVERYDOGGY_EVERYDOGGY';
        break;

      case 162:
        return 'everydoggy_2WEEK_29_99_USD_INTRO_7days_1_99_VET_CARE_EVERYDOGGY_EVERYDOGGY';
        break;
      case 163:
        return 'everydoggy_2WEEK_29_99_USD_INTRO_30days_6_99_VET_CARE_EVERYDOGGY_EVERYDOGGY';
        break;
      case 164:
        return 'everydoggy_1MONTH_49_99_USD_INTRO_90days_14_99_VET_CARE_EVERYDOGGY_EVERYDOGGY';
        break;
      case 165:
        return 'everydoggy_2WEEK_29_99_GBP_INTRO_7days_1_99_VET_CARE_EVERYDOGGY_EVERYDOGGY';
        break;
      case 166:
        return 'everydoggy_2WEEK_29_99_GBP_INTRO_30days_6_99_VET_CARE_EVERYDOGGY_EVERYDOGGY';
        break;
      case 167:
        return 'everydoggy_1MONTH_49_99_GBP_INTRO_90days_14_99_VET_CARE_EVERYDOGGY_EVERYDOGGY';
        break;
      case 168:
        return 'everydoggy_2WEEK_29_99_EUR_INTRO_7days_1_99_VET_CARE_EVERYDOGGY_EVERYDOGGY';
        break;
      case 169:
        return 'everydoggy_2WEEK_29_99_EUR_INTRO_30days_6_99_VET_CARE_EVERYDOGGY_EVERYDOGGY';
        break;
      case 170:
        return 'everydoggy_1MONTH_49_99_EUR_INTRO_90days_14_99_VET_CARE_EVERYDOGGY_EVERYDOGGY';
        break;
    }
  } else {
    switch(id) {
      case 12:
        return 'everydoggy_1MONTH_29_99_USD';
        break;
      case 15:
        return 'everydoggy_3MONTH_39_99_USD';
        break;
      case 13:
        return 'everydoggy_1YEAR_69_99_USD';
        break;
      case 16:
        return 'everydoggy_1MONTH_21_99_USD';
        break;
      case 17:
        return 'everydoggy_3MONTH_29_99_USD';
        break;
      case 18:
        return 'everydoggy_1YEAR_51_99_USD';
        break;
      case 19:
        return 'everydoggy_1MONTH_39_99_USD_EVERYDOGGY_EVERYDOGGY';
        break;
      case 25:
        return 'everydoggy_1MONTH_23_99_USD_EVERYDOGGY';
        break;
      case 36:
        return 'everydoggy_1MONTH_31_99_USD_EVERYDOGGY';
        break;
      case 37:
        return 'everydoggy_3MONTH_43_99_USD_EVERYDOGGY';
        break;
      case 38:
        return 'everydoggy_3MONTH_31_99_USD_EVERYDOGGY';
        break;
      case 39:
        return 'everydoggy_1WEEK_9_99_USD';
        break;
      case 40:
        return 'everydoggy_1WEEK_7_99_USD';
        break;
      case 43:
        return 'everydoggy_1WEEK_12_99_USD';
        break;
      case 44:
        return 'everydoggy_1MONTH_29_99_USD_TRAINER_CHAT';
        break;
      case 45:
        return 'everydoggy_3MONTH_39_99_USD_TRAINER_CHAT';
        break;
      case 31:
        return 'everydoggy_1MONTH_39_99_USD_INTRO_7days_6_99_EVERYDOGGY';
        break;
      case 32:
        return 'everydoggy_1MONTH_39_99_USD_INTRO_30days_19_99_EVERYDOGGY';
        break;
      case 33:
        return 'everydoggy_3MONTH_59_99_USD_INTRO_90days_29_99_EVERYDOGGY';
        break;
      case 46:
        return 'everydoggy_1MONTH_39_99_USD_INTRO_7days_4_99_EVERYDOGGY';
        break;
      case 47:
        return 'everydoggy_1MONTH_39_99_USD_INTRO_30days_14_99_EVERYDOGGY';
        break;
      case 48:
        return 'everydoggy_3MONTH_59_99_USD_INTRO_90days_19_99_EVERYDOGGY';
        break;

      case 50:
        return 'everydoggy_1MONTH_23_99_GBP_EVERYDOGGY';
        break;
      case 51:
        return 'everydoggy_3MONTH_31_99_GBP_EVERYDOGGY';
        break;
      case 52:
        return 'everydoggy_1YEAR_55_99_GBP_EVERYDOGGY';
        break;
        
      case 53:
        return 'everydoggy_1MONTH_16_99_GBP_EVERYDOGGY';
        break;
      case 54:
        return 'everydoggy_3MONTH_23_99_GBP_EVERYDOGGY';
        break;
      case 55:
        return 'everydoggy_1YEAR_41_99_GBP_EVERYDOGGY';
        break;

      case 56:
        return 'everydoggy_1MONTH_59_99_USD_EVERYDOGGY';
        break;
      case 57:
        return 'everydoggy_3MONTH_101_99_USD_EVERYDOGGY';
        break;
      case 58:
        return 'everydoggy_6MONTH_149_99_USD_EVERYDOGGY';
        break;
      case 59:
        return 'everydoggy_1MONTH_44_99_USD_EVERYDOGGY';
        break;
      case 60:
        return 'everydoggy_3MONTH_75_99_USD_EVERYDOGGY';
        break;
      case 61:
        return 'everydoggy_6MONTH_111_99_USD_EVERYDOGGY';
        break;
    
      case 62:
        return 'everydoggy_1MONTH_49_99_USD_INTRO_30days_15_19_EVERYDOGGY';
        break;
      case 63:
        return 'everydoggy_3MONTH_79_99_USD_INTRO_90days_25_99_EVERYDOGGY';
        break;
      case 64:
        return 'everydoggy_6MONTH_119_99_USD_INTRO_180days_37_99_EVERYDOGGY';
        break;
      case 65:
        return 'everydoggy_1MONTH_49_99_USD_INTRO_30days_11_69_EVERYDOGGY';
        break;
      case 66:
        return 'everydoggy_3MONTH_79_99_USD_INTRO_90days_19_99_EVERYDOGGY';
        break;
      case 67:
        return 'everydoggy_6MONTH_119_99_USD_INTRO_180days_28_79_EVERYDOGGY';
        break;
      case 68:
        return 'everydoggy_1MONTH_39_99_USD_INTRO_30days_11_99_EVERYDOGGY';
        break;
      case 69:
        return 'everydoggy_1MONTH_49_99_USD_INTRO_7days_4_99_EVERYDOGGY';
        break;
      case 70:
        return 'everydoggy_1MONTH_49_99_USD_INTRO_30days_11_99_EVERYDOGGY';
        break;
      case 71:
        return 'everydoggy_1MONTH_49_99_USD_INTRO_7days_3_99_EVERYDOGGY';
        break;
      case 72:
        return 'everydoggy_1MONTH_49_99_USD_INTRO_30days_8_99_EVERYDOGGY';
        break;

      case 73:
        return 'everydoggy_1MONTH_59_99_USD_INTRO_7days_4_99_EVERYDOGGY';
        break;
      case 74:
        return 'everydoggy_1MONTH_59_99_USD_INTRO_30days_11_99_EVERYDOGGY';
        break;
      case 75:
        return 'everydoggy_3MONTH_119_99_USD_INTRO_90days_25_99_EVERYDOGGY';
        break;
      case 76:
        return 'everydoggy_1MONTH_59_99_USD_INTRO_7days_3_99_EVERYDOGGY';
        break;
      case 77:
        return 'everydoggy_1MONTH_59_99_USD_INTRO_30days_8_99_EVERYDOGGY';
        break;
      case 78:
        return 'everydoggy_3MONTH_119_99_USD_INTRO_90days_19_99_EVERYDOGGY';
        break;

      case 79:
        return 'everydoggy_3MONTH_59_99_USD_INTRO_90days_25_99_EVERYDOGGY';
        break;
      case 80:
        return 'everydoggy_1MONTH_39_99_USD_INTRO_7days_3_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 81:
        return 'everydoggy_1MONTH_39_99_USD_INTRO_30days_8_99_EVERYDOGGY_EVERYDOGGY';
        break;

      case 82:
        return 'everydoggy_1MONTH_49_99_USD_INTRO_7days_1_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 83:
        return 'everydoggy_1MONTH_49_99_USD_INTRO_30days_6_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 84:
        return 'everydoggy_3MONTH_79_99_USD_INTRO_90days_14_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 85:
        return 'everydoggy_1MONTH_49_99_USD_INTRO_7days_0_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 86:
        return 'everydoggy_3MONTH_79_99_USD_INTRO_90days_9_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 87:
        return 'everydoggy_1MONTH_49_99_USD_INTRO_30days_3_99_NONE_NONE';
        break;

      case 88:
        return 'everydoggy_2WEEK_29_99_USD_INTRO_7days_4_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 89:
        return 'everydoggy_2WEEK_29_99_USD_INTRO_30days_11_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 90:
        return 'everydoggy_1MONTH_49_99_USD_INTRO_90days_25_99_EVERYDOGGY_EVERYDOGGY';
        break;

      case 91:
        return 'everydoggy_2WEEK_29_99_USD_INTRO_7days_3_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 92:
        return 'everydoggy_2WEEK_29_99_USD_INTRO_30days_8_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 93:
        return 'everydoggy_1MONTH_49_99_USD_INTRO_90days_19_99_EVERYDOGGY_EVERYDOGGY';
        break;

      case 94:
        return 'everydoggy_2WEEK_29_99_USD_INTRO_7days_1_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 95:
        return 'everydoggy_2WEEK_29_99_USD_INTRO_30days_6_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 96:
        return 'everydoggy_1MONTH_49_99_USD_INTRO_90days_14_99_EVERYDOGGY_EVERYDOGGY';
        break;

      case 97:
        return 'everydoggy_2WEEK_29_99_USD_INTRO_7days_0_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 98:
        return 'everydoggy_2WEEK_29_99_USD_INTRO_30days_3_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 99:
        return 'everydoggy_1MONTH_49_99_USD_INTRO_90days_9_99_EVERYDOGGY_EVERYDOGGY';
        break;

      case 101:
        return 'everydoggy_3MONTH_59_99_USD_INTRO_90days_39_99_EVERYDOGGY_EVERYDOGGY';
        break;

      case 103:
        return 'everydoggy_2WEEK_29_99_GBP_INTRO_7days_1_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 104:
        return 'everydoggy_2WEEK_29_99_GBP_INTRO_30days_6_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 105:
        return 'everydoggy_1MONTH_49_99_GBP_INTRO_90days_14_99_EVERYDOGGY_EVERYDOGGY';
        break;

      case 106:
        return 'everydoggy_2WEEK_29_99_GBP_INTRO_7days_0_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 107:
        return 'everydoggy_2WEEK_29_99_GBP_INTRO_30days_3_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 108:
        return 'everydoggy_1MONTH_49_99_GBP_INTRO_90days_9_99_EVERYDOGGY_EVERYDOGGY';
        break;

      case 109:
        return 'everydoggy_2WEEK_29_99_EUR_INTRO_7days_1_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 110:
        return 'everydoggy_2WEEK_29_99_EUR_INTRO_30days_6_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 111:
        return 'everydoggy_1MONTH_49_99_EUR_INTRO_90days_14_99_EVERYDOGGY_EVERYDOGGY';
        break;

      case 112:
        return 'everydoggy_2WEEK_29_99_EUR_INTRO_7days_0_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 113:
        return 'everydoggy_2WEEK_29_99_EUR_INTRO_30days_3_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 114:
        return 'everydoggy_1MONTH_49_99_EUR_INTRO_90days_9_99_EVERYDOGGY_EVERYDOGGY';
        break;

      case 115:
        return 'everydoggy_1MONTH_49_99_GBP_INTRO_7days_4_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 116:
        return 'everydoggy_1MONTH_49_99_GBP_INTRO_30days_11_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 117:
        return 'everydoggy_3MONTH_79_99_GBP_INTRO_90days_25_99_EVERYDOGGY_EVERYDOGGY';
        break;

      case 118:
        return 'everydoggy_1MONTH_49_99_GBP_INTRO_7days_3_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 119:
        return 'everydoggy_1MONTH_49_99_GBP_INTRO_30days_8_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 120:
        return 'everydoggy_3MONTH_79_99_GBP_INTRO_90days_19_99_EVERYDOGGY_EVERYDOGGY';
        break;

      case 121:
        return 'everydoggy_1MONTH_29_99_USD_INTRO_30days_1_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 122:
        return 'everydoggy_1MONTH_29_99_GBP_INTRO_30days_1_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 123:
        return 'everydoggy_1MONTH_29_99_EUR_INTRO_30days_1_99_EVERYDOGGY_EVERYDOGGY';
        break;

      case 124:
        return 'everydoggy_1MONTH_39_99_USD_INTRO_30days_19_99_TRAINER_CHAT_EVERYDOGGY_EVERYDOGGY';
        break;
      case 125:
        return 'everydoggy_1MONTH_39_99_GBP_INTRO_30days_19_99_TRAINER_CHAT_EVERYDOGGY_EVERYDOGGY';
        break;
      case 126:
        return 'everydoggy_1MONTH_39_99_EUR_INTRO_30days_19_99_TRAINER_CHAT_EVERYDOGGY_EVERYDOGGY';
        break;

      case 130:
        return 'everydoggy_1MONTH_39_99_GBP_EVERYDOGGY_EVERYDOGGY';
        break;
      case 131:
        return 'everydoggy_1MONTH_39_99_GBP_INTRO_30days_14_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 132:
        return 'everydoggy_3MONTH_59_99_GBP_INTRO_90days_39_99_EVERYDOGGY_EVERYDOGGY';
        break;

      case 133:
        return 'everydoggy_1MONTH_39_99_GBP_INTRO_30days_11_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 134:
        return 'everydoggy_3MONTH_59_99_GBP_INTRO_90days_29_99_EVERYDOGGY_EVERYDOGGY';
        break;

      case 135:
        return 'everydoggy_1MONTH_39_99_EUR_EVERYDOGGY_EVERYDOGGY';
        break;
      case 136:
        return 'everydoggy_1MONTH_39_99_EUR_INTRO_30days_14_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 137:
        return 'everydoggy_3MONTH_59_99_EUR_INTRO_90days_39_99_EVERYDOGGY_EVERYDOGGY';
        break;

      case 138:
        return 'everydoggy_1MONTH_39_99_EUR_INTRO_30days_11_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 139:
        return 'everydoggy_3MONTH_59_99_EUR_INTRO_90days_29_99_EVERYDOGGY_EVERYDOGGY';
        break;

      
      case 140:
        return 'everydoggy_3MONTH_64_99_USD_INTRO_90days_25_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 141:
        return 'everydoggy_6MONTH_94_99_USD_INTRO_180days_37_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 142:
        return 'everydoggy_3MONTH_64_99_USD_INTRO_90days_19_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 143:
        return 'everydoggy_6MONTH_94_99_USD_INTRO_180days_29_99_EVERYDOGGY_EVERYDOGGY';
        break;

      case 144:
        return 'everydoggy_3MONTH_64_99_GBP_INTRO_90days_25_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 145:
        return 'everydoggy_6MONTH_94_99_GBP_INTRO_180days_37_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 146:
        return 'everydoggy_3MONTH_64_99_GBP_INTRO_90days_19_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 147:
        return 'everydoggy_6MONTH_94_99_GBP_INTRO_180days_29_99_EVERYDOGGY_EVERYDOGGY';
        break;

      case 148:
        return 'everydoggy_3MONTH_64_99_EUR_INTRO_90days_25_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 149:
        return 'everydoggy_6MONTH_94_99_EUR_INTRO_180days_37_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 150:
        return 'everydoggy_3MONTH_64_99_EUR_INTRO_90days_19_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 151:
        return 'everydoggy_6MONTH_94_99_EUR_INTRO_180days_29_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 152:
        return 'everydoggy_3MONTH_64_99_USD_INTRO_90days_21_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 153:
        return 'everydoggy_6MONTH_94_99_USD_INTRO_180days_32_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 154:
        return 'everydoggy_3MONTH_64_99_GBP_INTRO_90days_21_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 155:
        return 'everydoggy_6MONTH_94_99_GBP_INTRO_180days_32_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 156:
        return 'everydoggy_3MONTH_64_99_EUR_INTRO_90days_21_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 157:
        return 'everydoggy_6MONTH_94_99_EUR_INTRO_180days_32_99_EVERYDOGGY_EVERYDOGGY';
        break;

      case 158:
        return 'everydoggy_2WEEK_39_99_USD_INTRO_30days_11_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 159:
        return 'everydoggy_1MONTH_49_99_USD_INTRO_90days_21_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 160:
        return 'everydoggy_1MONTH_49_99_USD_INTRO_180days_32_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 161:
        return 'everydoggy_2WEEK_39_99_GBP_INTRO_30days_11_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 162:
        return 'everydoggy_1MONTH_49_99_GBP_INTRO_90days_21_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 163:
        return 'everydoggy_1MONTH_49_99_GBP_INTRO_180days_32_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 164:
        return 'everydoggy_2WEEK_39_99_EUR_INTRO_30days_11_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 165:
        return 'everydoggy_1MONTH_49_99_EUR_INTRO_90days_21_99_EVERYDOGGY_EVERYDOGGY';
        break;
      case 166:
        return 'everydoggy_1MONTH_49_99_EUR_INTRO_180days_32_99_EVERYDOGGY_EVERYDOGGY';
        break;

      case 167:
        return 'everydoggy_2WEEK_29_99_USD_INTRO_7days_1_99_VET_CARE_EVERYDOGGY_EVERYDOGGY';
        break;
      case 168:
        return 'everydoggy_2WEEK_29_99_USD_INTRO_30days_6_99_VET_CARE_EVERYDOGGY_EVERYDOGGY';
        break;
      case 169:
        return 'everydoggy_1MONTH_49_99_USD_INTRO_90days_14_99_VET_CARE_EVERYDOGGY_EVERYDOGGY';
        break;
      case 170:
        return 'everydoggy_2WEEK_29_99_GBP_INTRO_7days_1_99_VET_CARE_EVERYDOGGY_EVERYDOGGY';
        break;
      case 171:
        return 'everydoggy_2WEEK_29_99_GBP_INTRO_30days_6_99_VET_CARE_EVERYDOGGY_EVERYDOGGY';
        break;
      case 172:
        return 'everydoggy_1MONTH_49_99_GBP_INTRO_90days_14_99_VET_CARE_EVERYDOGGY_EVERYDOGGY';
        break;
      case 173:
        return 'everydoggy_2WEEK_29_99_EUR_INTRO_7days_1_99_VET_CARE_EVERYDOGGY_EVERYDOGGY';
        break;
      case 174:
        return 'everydoggy_2WEEK_29_99_EUR_INTRO_30days_6_99_VET_CARE_EVERYDOGGY_EVERYDOGGY';
        break;
      case 175:
        return 'everydoggy_1MONTH_49_99_EUR_INTRO_90days_14_99_VET_CARE_EVERYDOGGY_EVERYDOGGY';
        break;

      // v001/v002/v003 — flat 1-day test subscriptions (dev/staging only, per catalog id)
      case 49:
        return 'everydoggy_1DAY_9_99_USD_EVERYDOGGY_EVERYDOGGY';
        break;
      case 179:
        return 'everydoggy_1DAY_9_99_EUR_EVERYDOGGY_EVERYDOGGY';
        break;
      case 178:
        return 'everydoggy_1DAY_9_99_GBP_EVERYDOGGY_EVERYDOGGY';
        break;
    }
  }
  
};
